<template>
	<div class="p_box">
		<div class="p_flex home_box p_f_b">
			<div class="p_f_1">
				<div class="p_flex">
					<div class="p_f_1 home_back" @click="goLayout">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">布置作业</span>
						<div class="home_img p_flex "><img src="../../../assets/img/buzhi.png" /></div>
					</div>
					<div class="p_f_1 home_back p_m_l_30" @click="goSelect">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">制作习题</span>
						<div class="home_img p_flex "><img src="../../../assets/img/zhizuo.png" /></div>
					</div>
				</div>
				<div class="p_flex p_m_t_30">
					<div class="p_f_1 home_back" @click="goMine(2)">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">我的题库</span>
						<div class="home_img p_flex "><img src="../../../assets/img/wd.png" /></div>
					</div>
					<div class="p_f_1 home_back p_m_l_30" @click="goMine(1)">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">校本题库</span>
						<div class="home_img p_flex "><img src="../../../assets/img/xiaoben.png" /></div>
					</div>
					<div class="p_f_1 home_back p_m_l_30" @click="goHui">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">慧题库</span>
						<div class="home_img p_flex "><img src="../../../assets/img/wd.png" /></div>
					</div>
				</div>
				<div class="p_flex p_m_t_30">
					<div class="p_f_1 home_back" @click="goSent">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">已发作业</span>
						<div class="home_img p_flex "><img src="../../../assets/img/wd.png" /></div>
					</div>
					<div class="p_f_1 home_back p_m_l_30" @click="goCorrect">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">待批改</span>
						<div class="home_img p_flex "><img src="../../../assets/img/zuoy.png" /></div>
					</div>
					<div class="p_f_1 home_back p_m_l_30" @click="goPerform">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">已完成作业</span>
						<div class="home_img p_flex "><img src="../../../assets/img/zuoy.png" /></div>
					</div>
				</div>
				<div class="p_flex p_m_t_30">
					<div class="p_f_1 home_back " @click="goAnalyse">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">作业分析报告</span>
						<div class="home_img p_flex "><img src="../../../assets/img/baog.png" /></div>
					</div>
					<div class="p_f_1 home_back p_m_l_30" @click="goWrong">
						<span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">错题批改</span>
						<div class="home_img p_flex "><img src="../../../assets/img/cuot.png" /></div>
					</div>
<!--					<div class="p_f_1  p_m_l_30">&lt;!&ndash; <span class="type_size_22 p_flex p_m_t_20 p_m_l_40 subject_white">制作习题</span &ndash;&gt;</div>-->
				</div>
			</div>
			<div class="home_news p_m_l_60">
				<span class="p_flex p_m_t_30 p_m_l_30 type_size_22">消息</span>
				<div class="p_m_t_30 p_m_l_30 p_m_r_30 home_center">
					<div class="small_hand" v-for="(item, index) in count" :key="index" @click="goDeatils(item.type, item.id)">
						<div class="p_flex p_f_a">
							<div class="news_box" v-show="item.type == 1 ? true : false"><img src="../../../assets/img/blue.png" /></div>
							<!-- 错题提问 -->
							<div class="news_box" v-show="item.type == 3 ? true : false"><img src="../../../assets/img/green.png" /></div>
							<!-- 其它信息 -->
							<div class="news_box" v-show="item.type == 2 ? true : false"><img src="../../../assets/img/orange.png" /></div>
							<!-- 学生提问 -->
							<div class="p_f_1 p_m_l_20">
								<div class="type_size_18" v-show="item.type == 3 ? true : false">{{ item.title }}</div>
								<div class="type_size_18" v-if="item.id" v-show="item.type == 1 ? true : item.type == 2 ? true : false">{{ item.student.name }}</div>
								<div class="one-overflow p_m_t_14 type_size_16 " v-show="item.type == 3 ? false : true">{{ item.student_content }}</div>
							</div>
							<div class="p_m_l_20">
								<div v-show="item.type == 3 ? false : true">{{ item.enquire_date }}</div>
								<div class="p_m_t_14 p_flex p_f_e">
									<el-badge type="danger" v-show="item.teacher_unread == 0 ? false : true" :value="item.teacher_unread" :max="99" class="item"></el-badge>
								</div>
							</div>
						</div>
						<el-divider></el-divider>
					</div>
				</div>
				<div class="home_btn type_size_16 subject_color small_hand" @click="goNews">查看全部</div>
			</div>
		</div>
		<div class="footer"><a href="javascript:" onClick="window.open('http://beian.miit.gov.cn/')">滇ICP备2021007786号</a></div>
	</div>
</template>

<script>
export default {
	name: 'Homet',
	data() {
		return {
			count: []
		};
	},
	created() {
		this.$request
			.ajax(this)
			.post('/api_teacher/news_list', {
				page: 1, //
				limit: 6
			})
			.then(res => {
				// console.log(res)
				this.count = res.data.list;
			});
	},
	methods: {
		goHui(){
			this.$router.push('/HuiQuestion');
		},
		goSelect() {
			this.$router.push('/Select');
		},
		goLayout() {
			this.$router.push('/Layout');
		},
		goMine(id) {
			this.$router.push({
				path: '/Mine',
				query: {
					id: id
				}
			});
		},
		goWrong() {
			this.$router.push('/Wrong');
			// this.$router.push('/Mistake');
		},
		goAnalyse() {
			this.$router.push('/Analyse');
		},
		goPerform() {
			this.$router.push('/Perform');
		},
		goSent() {
			this.$router.push('/Sent');
		},
		goCorrect() {
			this.$router.push('/Correct');
		},
		goNews() {
			this.$router.push('/News');
		},
		goDeatils(i, o) {
			if (i == 1) {
				this.$router.push({
					path: '/NewsError',
					query: {
						id: o,
						num: 1
					}
				});
				return;
			}
			if (i == 3) {
				this.$router.push('/Rest');
				return;
			}
			this.$router.push({
				path: '/Student',
				query: {
					id: o
				}
			});
		}
	}
};
</script>

<style lang="scss" scoped>
.p_box {
	max-width: 1200px;
}
.home_news {
	position: relative;
	width: 380px;
	height: 656px;
	background: #ffffff;
	opacity: 1;
	border-radius: 10px 10px 0px 0px;
}
img {
	width: 100%;
	height: 100%;
}

.news_box {
	width: 60px;
	height: 60px;
}

>>> .el-badge__content--danger {
	background-color: #f1282e;
}

.home_btn {
	position: absolute;
	bottom: 0;
	left: 0;
	width: 380px;
	height: 62px;
	background: #e2fff2;
	opacity: 1;
	border-radius: 0px;
	text-align: center;
	line-height: 62px;
}

.home_back {
	background: linear-gradient(135deg, #20e18d 0%, #00af63 100%);
	opacity: 1;
	border-radius: 20px;
	height: 160px;
}

.home_center {
	height: 500px;
	overflow-x: hidden;
	overflow-y: scroll;
	text-align: left;
}
.home_center::-webkit-scrollbar {
	display: none;
}
.home_img {
	width: 56px;
	height: 68px;
	margin-left: auto;
	margin-right: 40px;
	margin-top: 20px;
}
.footer {
	display: flex;
	justify-content: center;
	font-size: 16px;
	margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/home/home.vue